import { apiFetchJson, authenticatedJsonRequest } from "./api"

export function initialMapPreferences(serverPreferences, localPreferences = {}) {
  const server = plainObject(serverPreferences)
  return Object.keys(server).length ? server : plainObject(localPreferences)
}

export function mapPreferencesRequest(preferences, csrfToken = null) {
  return authenticatedJsonRequest({
    method: "PATCH",
    body: JSON.stringify({ preferences: plainObject(preferences) }),
    keepalive: true
  }, csrfToken)
}

export function saveMapPreferences(url, preferences) {
  return apiFetchJson(url, {
    method: "PATCH",
    body: JSON.stringify({ preferences: plainObject(preferences) }),
    keepalive: true
  })
}

function plainObject(value) {
  return value && typeof value === "object" && !Array.isArray(value) ? value : {}
}
